import { Grid, styled } from '../../../../base';

export const StyledAIInsightsSection = styled(Grid)(() => ({
    flex: '0 0 auto',
}));

export const StyledEvaluatedSkillsSection = styled(Grid)(({ theme }) => ({
    flex: '1 1 auto',
    marginTop: theme.spacing(2),
}));
